export default __webpack_public_path__ + "static/Product-Disclosure-Sheet_EGTB_EN-fb101f69092bf8cf7ea2fdfb5e4bca6e.pdf";